import {Outlet} from "react-router";
import {Alert} from "react-bootstrap";
import {useAuth} from "./AuthContext";
import {common} from "../i18n";

// Inside RequireAuth: signed in, but only site administrators get through.
export function RequireAdmin() {
    const {isAdmin} = useAuth();
    if (!isAdmin) {
        return <Alert variant="warning">{common.adminOnly}</Alert>;
    }
    return <Outlet/>;
}
